<template>
    <q-card
        :style="style"
        class="me"
        draggable="true"
        @dragstart.native="ondragstart"
        :inline="inline"
        :title="localModel.name">

        <q-card-main class="text-center">
            <div v-if="! showRealAudio">
                <a href="#"
                   @click.prevent="showRealAudio = true"
                >Kliknij by pokazać podgląd</a>
            </div>
            <template v-else>
                <q-btn round v-if="! playing" icon="music_note" @click="play"/>
                <q-btn round v-if="playing"   icon="music_off" @click="stop"/>

                <audio ref="audio" @ended="stop">
                    <source :src="prefixedSrc" :type="mediaType">
                    Your browser does not support the audio element.
                </audio>
            </template>

            <div class="name" v-if="localModel">{{localModel.name}}</div>
        </q-card-main>

        <q-card-actions v-if="deletable" align="end">
            <q-btn
                icon="delete"
                flat
                round
                v-if="deletable"
                @click="remove"
            />
        </q-card-actions>
    </q-card>
</template>

<script>
    import QIcon from 'quasar-framework/src/components/icon/QIcon'
    import QCardMain from 'quasar-framework/src/components/card/QCardMain'

    export default {
        name: 'AudioViewer',
        components: {QCardMain, QIcon},
        props: ['model', 'draggable', 'inline', 'src', 'deletable', 'width', 'height'],
        methods: {
            ondragstart (e) {
                e.dataTransfer.effectAllowed = 'copy'
                e.dataTransfer.setData('text', JSON.stringify(this.localModel))
            },
            fetchDetailsIfNecessary() {
            },
            play () {
                this.$refs.audio.play()
                this.playing = true
            },
            stop () {
                this.$refs.audio.pause()
                this.playing = false
            },
            remove () {
                this.$store.dispatch('remove', {
                    what: 'file',
                    id: this.localModel.id
                })
            }
        },
        watch: {
            model(current) {
                this.localModel = current;

                if (current) {
                    this.fetchDetailsIfNecessary();
                }
            }
        },
        mounted() {
            this.localModel = this.model;

            if (this.model) {
                this.fetchDetailsIfNecessary();
            }
        },
        data () {
            return {
                localModel: {},
                playing: false,
                showRealAudio: false
            }
        },
        computed: {
            mediaType () {
                if (this.localModel) {
                    return this.localModel.mediaType
                } else {
                    if (this.src.endsWith('.mp3')) {
                        return 'audio/mp3'
                    } else if (this.src.endsWith('.wav')) {
                        return 'audio/wav'
                    }
                }
            },
            prefixedSrc () {
                const src = this.src || this.localModel.urlPath
                return this.$store.state.MEDIA_PREFIX + src
            },
            style () {
                let s = '';

                if (this.width) {
                    s += `width: ${this.width}px; `
                }

                if (this.height) {
                    s += `height: ${this.height}px; `
                }

                return s
            }
        },
    }
</script>

<style scoped lang="scss">
    .me {
        position: relative;

        .name {
            overflow: hidden;
            -ms-text-overflow: ellipsis;
            text-overflow: ellipsis;
        }
    }
</style>